"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = void 0;
var formatCurrency = function (number, locales, currency) {
  if (locales === void 0) {
    locales = 'en-US';
  }
  if (currency === void 0) {
    currency = 'USD';
  }
  if (!number) {
    return '-';
  }
  return new Intl.NumberFormat(locales, {
    style: 'currency',
    currency: currency
  }).format(number);
};
exports.formatCurrency = formatCurrency;